import '../../../common/dashboard/filters/filter.js.coffee';# Added by Script 
Namespace 'CustomerVisualMode.Filters'

class CustomerVisualMode.Filters.StatusFilter extends Common.Dashboard.Filters.Filter

  @FILTER_TYPE: 'status'
  removable: true
  possibleValues:
    not_assigned: 'Not Assigned'
    assigned: 'Assigned'
    pending: 'Pending'
    closed: 'Closed'

  getFilterType: ->
    CustomerVisualMode.Filters.StatusFilter.FILTER_TYPE

  getValues: ->
    return [] unless @values
    for value in @values
      name = Object.keys(@possibleValues).find((key) => @possibleValues[key] == value)
      id: value
      name: I18n.t("common.ticket.status.#{name}")

  hasValues: ->
    @values.length != 0

  _valuesToJSON: ->
    @values

  removeValue: (valueToRemove) ->
    @values = _.reject(@values, (value) -> value == valueToRemove.id)
